import { createContext, useContext, useState } from "react";

// Which sender environment the lists show. `env` is part of log-pile's index
// key, so a list is always for exactly one env; the site defaults to its own
// stage (dev site → "dev", prod site → "prod") and remembers a change.
const STORAGE_KEY = "log-pile.env";
const DEFAULT_ENV = import.meta.env.VITE_STAGE || "dev";
export const KNOWN_ENVS = Array.from(new Set([DEFAULT_ENV, "dev", "prod", "local"]));

const read = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) || DEFAULT_ENV;
  } catch {
    return DEFAULT_ENV;
  }
};

const envContext = createContext<{ env: string; setEnv: (env: string) => void }>({ env: DEFAULT_ENV, setEnv: () => {} });

export const EnvProvider = ({ children }: { children: React.ReactNode }) => {
  const [env, setEnvState] = useState(read);
  const setEnv = (next: string) => {
    const clean = next.trim();
    if (!/^[a-z0-9-]+$/i.test(clean)) return;
    setEnvState(clean);
    try {
      window.localStorage.setItem(STORAGE_KEY, clean);
    } catch {
      /* per-viewer convenience only */
    }
  };
  return <envContext.Provider value={{ env, setEnv }}>{children}</envContext.Provider>;
};

export const useEnv = () => useContext(envContext);
